import { jsx as _jsx } from "react/jsx-runtime";
import { GainfulButton } from "CheckoutComponents";
import styles from "./styles.module.css";
export default function StickyBottom(props) {
    return (_jsx("div", { className: styles.stickybottom, children: _jsx(GainfulButton, { onClick: props.handleClick, text: props.text, size: "xlarge", disabled: props.buttonDisabled }) }));
}
